import toTranslit from '../../util/cyrillic-to-translit';
import { backendUrl } from '../../lib/config';
import * as MediaFileEditMutation from '../../mutations/MediaFileEditMutation';
import modernEnvironment from '../../lib/RelayUtils';
import setCategory from './setCategory';

const headers = { 'Content-Type': 'application/json' };
const query = `query PopupMeta_item_Query(
  $id: ID!
) {
  node(id: $id) {
    ... on MediaFile {
      preview
      id
      slug
      description
      filename
      alt
      type
      title
      authors
      show
      topics {
        id
      }
      status
      seoKeywords
      seoDescription
      seoTitle
      status
      type
    }
    id
  }
}`;

const checkData = (originalData, newData) => {
    const sendData = {
        state: 'available',
        ...originalData,
        slug: originalData.slug && originalData.slug.length ? originalData.slug : '',
    };
    const changeFields = ['title', 'topics', 'description', 'slug'];
    let updateFlag = false;
    for (const field of changeFields) {
        const currentField = typeof originalData[field] === 'string' ? originalData[field].trim() : originalData[field];
        if (
            (!currentField && newData[field] && newData[field].length) ||
            (sendData[field] && !sendData[field].length)
        ) {
            sendData[field] = newData[field];
            updateFlag = true;
        }
    }
    if (!sendData.slug) {
        sendData.slug = toTranslit(sendData.title);
        updateFlag = true;
    }
    sendData.topics = sendData.topics.map(topic => topic.id);
    if (sendData.show && !sendData.show.length) {
        sendData.show = setCategory();
        updateFlag = true;
    }
    if (updateFlag) {
        MediaFileEditMutation.commit(modernEnvironment, sendData, (result) => {});
    }
};

const updateMediaFiles = (id, data) => {
    const variables = { id };
    return fetch(
        `${backendUrl}/graphql`,
        {
            method: 'POST',
            headers,
            body: JSON.stringify({
                query,
                variables,
            }),
        },
    )
        .then(response => response.json())
        .then((response) => {
            if ({}.hasOwnProperty.call(response, 'data')) {
                if (response.data && response.data.node) {
                    return checkData(response.data.node, data);
                }
                return null;
            }
            return null;
        });
};

export default updateMediaFiles;



// WEBPACK FOOTER //
// src/components/media/updateMediaFile.js